import React,{Component}from 'react';
const shallowEqualObjects = require('shallow-equal/objects');

export default class tags extends Component{
    constructor(){
        super();
        this.oldTags = [];
    }
    componentDidUpdate(){
        let _this = this;
        _this.refs.tagsWrap.classList.add('show');
        setTimeout(function(){
            _this.refs.tagsWrap.classList.remove('show');
        },1500)
    }
    shouldComponentUpdate(nextProps){
        let oldTags = this.oldTags,
            tags = nextProps.tags;
        if(oldTags.length === tags.length){
            for(let i =0;i<oldTags.length;i++){
                if(!shallowEqualObjects(oldTags[i],tags[i])){
                    return true;
                }
            }
            return false;
        }
        return true;
    }
    render(){
        const {tags,handleClickTag} = this.props;
        tags.push({value:"去app体验",label:"去app体验"})
        this.oldTags = tags;
        return (
            <div className="tags-area">
            <div className="tags-wrap" ref="tagsWrap">
                <ul>
                {
                    tags.map((item,index)=>{
                        return (<li className="tags-item" data-label={item.label} data-value={item.value} key={'tag'+index} onClick={handleClickTag}>{item.label}</li>)
                    })
                }
                </ul>
            </div>
         </div>
        )
    }
        
}